import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface KeyPair {
  publicKey: string;
  privateKey: string;
}

interface CardSecurityState {
  publicKey: string | null;
  privateKey: string | null;
  showSensitiveData: boolean;
  cardId: number | null;
  timeoutId: number | null;
}

const initialState: CardSecurityState = {
  publicKey: null,
  privateKey: null,
  showSensitiveData: false,
  cardId: null,
  timeoutId: null,
};

const cardSecuritySlice = createSlice({
  name: 'cardSecurity',
  initialState,
  reducers: {
    setKeys: (state, action: PayloadAction<KeyPair>) => {
      state.publicKey = action.payload.publicKey;
      state.privateKey = action.payload.privateKey;
    },
    setShowSensitiveData: (state, action: PayloadAction<{ show: boolean; cardId: number | null }>) => {
      state.showSensitiveData = action.payload.show;
      state.cardId = action.payload.cardId;
    },
    setTimeoutId: (state, action: PayloadAction<number>) => {
      // Clear existing timeout if any
      if (state.timeoutId !== null) {
        window.clearTimeout(state.timeoutId);
      }
      state.timeoutId = action.payload;
    },
    clearCardSecurity: (state) => {
      if (state.timeoutId !== null) {
        window.clearTimeout(state.timeoutId);
      }
      return initialState;
    },
  },
});

export const { setKeys, setShowSensitiveData, setTimeoutId, clearCardSecurity } = cardSecuritySlice.actions;
export default cardSecuritySlice.reducer; 